<template>
  <div class="contair">
    <div class="content">
      <div class="logoImg">
        <img src="../../assets/images/logo.png" />
      </div>
      <div class="inputContair">
        <div class="titleText">
          <p>用户注册</p>
          <!-- <p>天算 v2019.08.24</p> -->
        </div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item prop="phone">
            <form>
            <el-input type="text" v-model.trim="ruleForm.phone" autocomplete="off" placeholder="手机"></el-input>
            </form>
            <i class="iconfont icon-shouji"></i>
          </el-form-item>
          <el-form-item prop="verificationCode" class="verificationCode">
            <form>
            <el-input type="text" v-model.trim="ruleForm.verificationCode" autocomplete="off" placeholder="验证码" class="codeBox"></el-input>
            </form>
            <i class="iconfont icon-iconfront-"></i>
            <div class="verification" v-if="countdownClickDisabled" style="background-color: #C0C0C0;cursor: pointer;">
              <span class="message">{{verificationMsg}}</span>
            </div>
            <div class="verification" @click="getVerificationCode" style="background-color: #55ACEE;cursor: pointer;" v-else>
              <span class="message">{{verificationMsg}}</span>
            </div>
          </el-form-item>
          <el-form-item prop="pass">
            <el-input type="password" v-model.trim="ruleForm.pass" autocomplete="off" placeholder="密码"></el-input>
            <i class="iconfont icon-mima"></i>
          </el-form-item>
          <el-form-item prop="checkPass">
            <el-input type="password" v-model.trim="ruleForm.checkPass" autocomplete="off" placeholder="确认密码"></el-input>
            <i class="iconfont icon-mima"></i>
          </el-form-item>
          <el-form-item prop="nickname">
            <el-input v-model.trim="ruleForm.nickname" type="text" placeholder="昵称"></el-input>
            <i class="iconfont icon-nicheng"></i>
          </el-form-item>
			<el-form-item prop="name">
			  <el-input v-model.trim="ruleForm.name" type="text" placeholder="真实姓名"></el-input>
			  <i class="iconfont icon-nicheng"></i>
			</el-form-item>
			<el-form-item prop="remark2">
			  <el-input v-model.trim="ruleForm.remark2" type="text" placeholder="所属公司"></el-input>
			  <i class="iconfont icon-nicheng"></i>
			</el-form-item>
			<el-form-item prop="profession">
			  <el-input v-model.trim="ruleForm.profession" type="text" placeholder="部门及职务"></el-input>
			  <i class="iconfont icon-nicheng"></i>
			</el-form-item>
          <div class="agreeBox">
            <input type="checkbox" @click="agreeTreaty()" /><span>同意用户协议</span>
          </div>
          <el-form-item class="register">
            <el-button type="primary" @click="submitForm('ruleForm')" :disabled="isdisabled" class="registerButton">注册</el-button>
          </el-form-item>
        </el-form>
        <div class="otherLogin">
       <!--   <p class="chat">使用微信登录并注册 <i class="iconfont icon-weixin"></i></p> -->
		   <p class="chat"></p>
          <p class="login">
            <span>
              <router-link to="/userLogin" class="loginIn">已有账号登录</router-link>
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  export default ({
    name: 'userRegistration',
    components: {

    },
    data() {
      var checkMust = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入必填项'));
        } else{
		callback();
		}
      };
    
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(value))) {
          callback(new Error('8-16位字母或数字，且必须同时包含数字和字母'));
        }else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var checkPhone = (rule, value, callback) => {
        this.countdownClickDisabled=true;//手机号码验证通过前不允许点击发送验证码
        if (value === '') {
          callback(new Error('请输入手机号码'));
        } else if (!(/^1[3456789]\d{9}$/.test(value))) {
          callback(new Error('手机号码有误，请重新填写'));
        } else {
          //校验手机号在本系统是否已注册
          this.validateInfo({
            "mobile": value,"validateMobile":true
          }, callback);
          // callback();
        }
      };
      var checkVerificationCode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入验证码'));
        } else {
          if(this.countdownTime<0){
            callback(new Error('验证码超时'));
          }else{
            //校验验证码是否正确
            this.validateInfo({
              "verificationCode": value, "mobile": this.ruleForm.phone
            }, callback);
            // callback();
          }
        }
      };
      return {
        verificationMsg: '获取验证码',
        countdownTime: this.$store.state.defaultCountdownTime,//倒计时秒
        countdownClickDisabled:true,//验证码发送控制  false:可点击   true:不可点击
        ruleForm: {
          pass: '',
          checkPass: '',
          nickname: '',
		  name: '',
		  remark2: '',
		  profession: '',
          phone: '',
          verificationCode: ''
        },
        isdisabled: true,
        rules: {
          pass: [{
            validator: validatePass,
            trigger: 'blur'
          }],
          checkPass: [{
            validator: validatePass2,
            trigger: 'blur'
          }],
          nickname: [{
            validator: checkMust,
            trigger: 'blur'
          }],
		  name: [{
		    validator: checkMust,
		    trigger: 'blur'
		  }],
		  remark2: [{
		    validator: checkMust,
		    trigger: 'blur'
		  }],
		  profession: [{
		    validator: checkMust,
		    trigger: 'blur'
		  }],
          phone: [{
            validator: checkPhone,
            trigger: 'blur'
          }],
          verificationCode: [{
            validator: checkVerificationCode,
            trigger: 'blur'
          }]
        }
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.isdisabled === true) {
              this.$message({
                type: 'warning',
                message: `请阅读并勾选【同意用户协议】!`
              });
            } else {
              this.regist();
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      agreeTreaty() {
        if (this.isdisabled == true) {
          this.isdisabled = false;
        } else {
          this.isdisabled = true;
        }
      },
      regist() {
        let this_ = this;
        var data_ = {
          "userType": this_.$store.state.defaultUserType,
          "loginMode": "0",
          "client": this_.$store.state.defaultClient,
          "clientSys": this_.$store.state.defaultClientSys,
          "nickname": this_.ruleForm.nickname, //昵称
		  "name": this_.ruleForm.name, 
		  "remark2": this_.ruleForm.remark2, 
		  "profession": this_.ruleForm.profession, 
          "companyid": "CQJXKJ",
          "officeid": "HYZX001",
          "password": this_.ruleForm.pass, //密码
          "mobile": this_.ruleForm.phone, //手机号码
          "verificationCode": this_.ruleForm.verificationCode ,//验证码
          "systemcode":this_.$store.state.systemcode //系统编号
        };
        let paramdata = {};
        paramdata.url = '/jwt/user/resgist';
        paramdata.data = data_; //json对象
        paramdata.onSuccess = function(res) {
          if (res.data.ok) {
            //注册成功
            this_.registSuccess(res.data.result);
          } else {
            this_.$message.error('注册失败原因:' + res.data.errmsg);
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      registSuccess(parm_) { //注册成功后操作
        let this_ = this;
        var data_ = {
          "userType": this_.$store.state.defaultUserType,
          "loginMode": "0",
          "client": this_.$store.state.defaultClient,
          "clientSys": this_.$store.state.defaultClientSys,
          "systemcode":this_.$store.state.systemcode //系统编号
        };

        data_.loginName = parm_.loginName;
        data_.password = parm_.password;
        data_.mobile = parm_.mobile;
        let paramdata = {};
        paramdata.url = '/jwt/token/login';
        paramdata.data = data_; //json对象
        paramdata.onSuccess = function(res) {
          if (res.data.ok) {
            var userInfo = res.data.result.userInfo;
            userInfo.token = res.data.result.token;
            //默认自动登录
            userInfo.autoLogin = false;
            // 将用户token保存到vuex中
            this_.$store.commit('LOGIN', userInfo);
            // //登录成功 跳转会员中心首页
            // this_.$router.push('/');
            //登录成功 跳转注册成功页面
            this_.$router.push('/registerSuccess');
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      validateInfo(data_, callback) {
        let this_ = this;
        //判断传入json对象是否为空
        if (data_ === null || qs.stringify(data_) === "{}") {
          data_ = {
            "mobile": this_.ruleForm.phone
          }; //默认验证手机号码
        }
        let paramdata = {};
        paramdata.url = '/jwt/user/validate';
        paramdata.data = data_; //json对象
        paramdata.onSuccess = function(res) {
          if (res.data.ok) {
            if(data_.validateMobile){
              this_.countdownClickDisabled=false;//手机号码验证通过后允许点击发送验证码
            }
            callback();
          } else {
            let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
            callback(new Error(errmsg));
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      // 获取验证码
      getVerificationCode(){
        //控制不能重复请求
        if(this.countdownClickDisabled)return;
        this.countdownClickDisabled = true;
        let this_ = this;
        var data_ = {
          "userType": "1",
          "loginMode": "0",
          "client": "PC",
          "companyid": this_.$store.state.defaultCompanyid,
          "officeid": this_.$store.state.defaultOfficeid,
          "client": this_.$store.state.defaultClient,
          "clientSys": this_.$store.state.defaultClientSys,
          "systemcode":this_.$store.state.systemcode, //系统编号
          "projectno":this_.$store.state.projectno,//项目编号
          "mobile": this_.ruleForm.phone //手机号码
        };
        let paramdata = {};
        paramdata.url = '/jwt/user/sendVerificationCode';
        paramdata.data = data_; //json对象
        paramdata.onSuccess = function(res) {
          if (res.data.ok) {
            //获取验证码
            this_.countdown();
          } else {
            this_.countdownClickDisabled = false;//获取验证码失败，解禁获取按钮
            this_.$message.error('获取验证码失败原因:' + res.data.errmsg);
          }
        };

        paramdata.onFailed = function(res) {
          this_.countdownClickDisabled = false;//获取验证码失败，解禁获取按钮
        };

        this_.$axiosUtil.postServer(paramdata);

      },
      // 获取验证码倒计时
      countdown() {
        // if(this.countdownClickDisabled)return;
        // this.countdownClickDisabled = true;
        this.countdownTime = this.$store.state.defaultCountdownTime;
        this.verificationMsg = this.countdownTime + 's后重新获取'

        let clock = window.setInterval(() => {

          this.countdownTime--;

          this.verificationMsg = this.countdownTime + 's后重新获取';

          if (this.countdownTime < 0) {

            window.clearInterval(clock);

            this.verificationMsg = '重新获取验证码';

            this.countdownClickDisabled = false;

          }

        }, 1000);
      }
    }
  })
</script>

<style lang="scss" scoped>
  .contair {
    width: 100%;
    height: 100%;
    background: #252B3A;
  }

  .content {
    width: 1280px;
    margin: 0px auto;
    background: #252B3A;
  }

  .logoImg {
    margin: 0px auto;
    background: #252B3A;
    padding-top: 50px;
    width: 100px;
    padding-bottom: 20px;
  }

  .logoImg>img {
    background: #252B3A;
    width: 100px;
  }

  .inputContair {
    margin: 0px auto;
    padding: 20px 30px;
    /* background: #4d587359; */
    background: rgba(77, 88, 115, 0.35);
    width: 460px;
  }

  .titleText {
    color: #ffffff;
    text-align: center;
    padding-bottom: 10px;
  }

  .titleText>p:first-of-type {
    font-size: 36px;
    margin: 0px;
    line-height: 40px;
  }

  .titleText>p:last-of-type {
    font-size: 14px;
    margin: 0px;
    line-height: 20px;
  }

  .el-form-item__label {
    color: #ffffff;
  }

  >>>.el-form-item__content {
    margin-left: 30px !important;
    display: flex;
  }

  >>>.el-input__inner {
    width: 400px;
    border-radius: $border-radius;
    padding-left: 25px;
  }

  .verificationCode {
    display: flex;
  }

  .codeBox {
    width: 250px;
    margin-right: 10px;
  }

  >>>.codeBox>.el-input__inner {
    width: 250px
  }

  .verification {
    width: 140px;
    height: 40px;
    text-align: center;
    background: #ffffff;
  }

  .verification>p {
    margin: 0px;
    line-height: 40px;
    font-size: 16px;
  }

  .agreeBox {
    color: #ffffff;
    padding-left: 30px;
  }

  .register {
    margin-top: 20px;
  }

  >>>.register .el-form-item__content {
    width: 400px;
  }

  .register button {
    width: 400px;
    background: $color-primary;
    color: #ffffff;
    border: 1px solid $color-primary;
  }

  .register button:hover {
    background: $color-primary-light-1;
  }

  .otherLogin {
    display: flex;
    color: #ffffff;
    padding: 0px 30px;
  }

  .otherLogin>p:first-of-type {
    text-align: left;
    width: 50%;
  }

  .otherLogin>p:last-of-type {
    text-align: right;
    width: 50%;
  }

  .message {
    text-decoration: none;
    font-size: 14px;
  }

  .icon-weixin {
    color: #1afa29;
    background: #ffffff;
    border-radius: 50%;
    vertical-align: 0;
  }

  .icon-shouji,
  .icon-iconfront-,
  .icon-mima,
  .icon-nicheng {
    position: absolute;
    top: 0px;
    left: 5px;
    font-size: 16px;
    color: #CCCCCC;
    height: 40px;
    width: auto;
    line-height: 40px;
  }

  .chat,
  .login>span:hover {
    cursor: pointer;
  }

  .loginIn {
    font-size: 16px;
    color: #ffffff;
  }

  >>>.el-button {
    border-radius: $border-radius;
  }
</style>



// WEBPACK FOOTER //
// src/page/memberCenter/userRegistration.vue